import React,{useState,useEffect,useCallback,useRef} from 'react'
import classes from './VideoPage.module.css'
import ReactPlayer from 'react-player'
import Navbar from '../Components/Navbar'
import VideoList from '../Components/VideoList'
import 'primeicons/primeicons.css';
import {Link,useNavigate,useParams} from 'react-router-dom'
import { GetCategories, GetVideoById, GetVideos } from '../Services/ApiFunction'
import Lottie from 'lottie-react'
import loader from '../Animations/Loader.json'
import Cookies from 'js-cookie'
import { post_content_detail } from '../Services/Apis'
import axios from 'axios'
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";



const VideoPage = () => {
  const videoRef = useRef(null);
  const [video,setVideo] = useState()

  const navigate = useNavigate()
  const {id} = useParams();


  const [watchTime, setWatchTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [url,setUrl] = useState(null)

  const [videoSrc,setVideoSrc] = useState(null)

 
  // Track when video starts/stops
  const handlePlay = () => {
    setIsPlaying(true);
    console.log(`Video Started: ${video?.content_name}`);
  };

  const handlePause = () => {
    setIsPlaying(false);
    console.log(`Video Paused at ${watchTime}s: ${video?.content_name}`);
  };

  const handleEnded = () => {
    console.log(`Video Finished: ${video?.content_name}`);
  };


   const params = new URLSearchParams(window.location.search)
    const extId = params.get('ext_ref') 

  const number = Cookies.get('sub_number')
  const [categories,setCategories] = useState([]);
    const [loading,setLoading] = useState(false);
    function formatWatchTime(seconds) {
      let minutes = Math.floor(seconds / 60);
      let remainingSeconds = Math.floor(seconds % 60); // Remove decimals
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }
  
  
  
    const fetchCategories = useCallback(
      async() => {
        setLoading(true);
        try{
          const res = await GetCategories();
          if (res && Array.isArray(res)) {
            setCategories(res);
          }
        }
        catch(err){
          console.log(err);
        }
        setLoading(false)
      },
      [],
    )

    useEffect(()=>{
        fetchCategories()
      },[fetchCategories])

      const postTimeTrack=async()=>{
        if(video?.content_name !== undefined){
          const data ={
            mobile_number:number,
            content_name:video?.content_name,
            duration:formatWatchTime(watchTime)
          }

          const duration = formatWatchTime(watchTime)
          if (duration == "0:00" || duration == "00:00") {
            console.log("Duration is 0:00, skipping API call.");
            return;
          }

          console.log(data,'data----------')
          const res = await axios.post(post_content_detail,data);
          console.log(res.data,'response-------------')
          
        }
      }


      useEffect(()=>{
        if(number && watchTime > 0){
          postTimeTrack()
        }
        console.log('video switched :: ',video?.content_name)
      },[navigate])

      
    


  const fetchData=async()=>{
    const res = await GetVideos();
    const allVideos = Object.values(res).flat();
    // console.log(allVideos)
    const filteredVideo = allVideos.filter(video => video.id == id);
    console.log(filteredVideo[0])
    setVideo(filteredVideo[0]);

    setUrl(`https://eurekacontent.gameit.in/${filteredVideo[0]?.category}/${encodeURIComponent(filteredVideo[0]?.video_path)}`)
  }

  useEffect(() => {
    fetchData()
  }, [id])

  useEffect(()=>{
    window.scrollTo({
      top: 0, // Scroll to the top
      behavior: 'smooth', // Adds a smooth scrolling effect
    });
  },[id])


      const checkSubscription=async()=>{
        if(!number){
            setTimeout(()=>{
              window.location.href = `http://seenvd.com/api/header?ext_ref=${extId}`
            },10000)
            return;
        }        
        };






  
        useEffect(()=>{
          checkSubscription()
        },[])




 

  return (
    <div className={classes.container}>
    
    <Navbar Categories={categories}/>
    <div className={classes.main}>
      <div className={classes.player}>
      <ReactPlayer
      ref={videoRef}
      url={video?.v_url}
      //  url={`https://eurekacontent.gameit.in/${video?.category}/${video?.video_path}`}
      
      controls
      playing={true}
      width="100%"
      height="80vh"
      loop={false}
      muted={false}
      playbackRate={1}
      config={{
        file: {
          attributes: {
            preload: 'auto',
            crossOrigin: true,
            playsInline: true,
          },
        },
      }}
      className='bg-black'

      onProgress={({ playedSeconds }) => setWatchTime(playedSeconds)}
  onPlay={handlePlay}
  onPause={handlePause}
  onEnded={handleEnded}
      

      // style={{height:'50rem'}}
    />


   

      </div>

      <h2 className='text-center text-white text-2xl font-bold'>{video?.content_name}</h2>
      <p className='text-center text-white text-lg font-semibold'>Category- {video?.category}</p>

      <br/>
    <hr className='text-gray-400 w-full'/>
    

    <div className={classes.videoList}>
    <h2 className={classes.title}>Related Videos</h2>
    <br/>
    <VideoList category={video && video?.category} number={5} id ={video && video?.id}/>

    </div>
    </div>
    
    </div>
  )
}

export default VideoPage
